import { ACCESS_USERID_KEY } from '@/constant/config';
import { GameItemType } from '@/pages/game/components/gameitem';
import { getGamesUrl } from '@/utils/img';
import { request } from '@/utils/request';

/** 获取收藏额游戏列表 */
export const getCollectGames = () =>
  request({
    url: '/gamer/get_collects'
  });
/**
 * 获取游戏配置
 * @returns
 */
export const getGames = async (): Promise<{
  games: GameItemType[];
  advertises: GameItemType[];
  recommend: GameItemType[];
  [x: string]: any;
}> => {
  try {
    const gameLayout = await request({
      url: '/gamer/get_game_layout',
      method: 'post',
      data: {
        directIn: 1,
        version: 1,
        roomconfigname: import.meta.env.VITE_GAME_ROOM_CONFIG_NAME,
        configname: import.meta.env.VITE_GAME_CONFIG_NAME
      }
    });
    const games: GameItemType[] = [];

    gameLayout.config.forEach(array => {
      array.forEach(item => {
        const { room_list, pack, gamename, h5_game_sort, available } = item;
        if (available) {
          games.push({
            order: h5_game_sort,
            room_list,
            available: available,
            gamename,
            pack,
            img: getGamesUrl(pack)
          });
        }
      });
    });

    const gameJson = await getLabelGames();
    const list = (gameJson?.games || [])
      .filter(item => item.enable)
      .map(item => {
        const targetItem = games.find(game => game.pack === item.pack);
        return {
          ...targetItem,
          ...item
        };
      })
      .sort((a, b) => (a.sort.HOT - b.sort.HOT < 0 ? -1 : 1));
    return Promise.resolve({
      games: list,
      advertises: gameJson?.advertise?.map(game => list?.find(item => item.pack === game)) || [],
      recommend: gameJson?.recommend?.map(game => list?.find(item => item.pack === game)) || [],
      christmas:
        gameJson?.christmas
          ?.map(game => list?.find(item => item.pack === game))
          ?.filter(Boolean)
          ?.map(game => ({ ...game, img: `${game.img}?v=christmas` })) || [],
      fish:
        gameJson?.fish
          ?.map(game => list?.find(item => item.pack === game))
          ?.filter(Boolean)
          ?.map(game => ({ ...game, img: `${game.img}?v=20250110` })) || []
    });
  } catch (error) {
    return Promise.resolve({
      games: [],
      advertises: [],
      recommend: [],
      christmas: [],
      fish: []
    });
  }
};

/**
 * 退出游戏
 * @returns
 */
export const exitGame = () => {
  return request({
    url: '/gamer/exitGame',
    method: 'post'
  });
};
/**
 * 进入游戏
 * @returns
 */
export const entryGame = data => {
  return request({
    url: '/gamer/getLink',
    method: 'post',
    data
  });
};

/**
 * 获取游戏列表
 */
export const test = () => {
  return request({
    url: `/tcenter/flush_balance?userid=${localStorage.getItem(ACCESS_USERID_KEY)}`
  });
};

/**
 * 获取新用户进入游戏房间
 */
export const getGuideGame = data => {
  return request({
    url: '/gamer/get_guide_game',
    method: 'post',
    data
  });
};

/**
 * 查询订阅数据
 */
export const getSubscribeData = data => {
  return request(
    {
      url: '/gamer/get_subscribe_data_pe',
      method: 'post',
      data
    },
    {
      skipErrorHandle: true
    }
  );
};

/**
 * 上报订阅结果接口
 */
export const uploadSubscribeState = data => {
  return request({
    url: '/gamer/upload_subscribe_state_pe',
    method: 'post',
    data
  });
};

/** 获取一label 为维度的game列表 */
export const getLabelGames = () =>
  fetch(`${window.imgPrefix}/game_data/game.json?v=${(window as any).instanceKey}`).then(res => res.json());

/**
 * 获取固定的游戏顺序
 * 主要是为分包服务的
 * */
export const getFixedGameOrder = () => fetch(`${window.imgPrefix}/game-order.json`).then(res => res.json());
